import { Tooltip } from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";

const ToolTip = ({ title, placement = "top" }) => {
  return (
    <Tooltip arrow placement={placement} title={title}>
      <InfoIcon
        sx={{ color: "#1F78FF", fontSize: "18px", cursor: "pointer" }}
      />
    </Tooltip>
  );
};

export default ToolTip;
